<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">制造单号</label>
            <em class="weui-form-preview__value">{{ form.main.ma_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.ma_custname" slot="ma_custname">
            <label class="weui-form-preview__label">{{customLabel.ma_custname || "客户"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.ma_custname
            }}</em>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_salecode" slot="ma_salecode">
            <label class="weui-form-preview__label">{{customLabel.ma_salecode || "订单"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ma_salecode
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_delivery" slot="ma_delivery">
            <label class="weui-form-preview__label">{{customLabel.ma_delivery || "交货日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ma_delivery
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ma_kind">
            <label class="weui-form-preview__label">{{customLabel.ma_kind || "制造类型"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ma_kind
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_code">
            <label class="weui-form-preview__label">{{customLabel.pr_code || "产品编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_code
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "产品型号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_brand" slot="pr_brand">
            <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
            <span class="weui-form-preview__value">
              <span class="list-item-status">{{ form.main.pr_brand }}</span>
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_spec" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_spec
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_wcname" slot="ma_wcname">
            <label class="weui-form-preview__label">{{customLabel.ma_wcname || "工作中心"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ma_wcname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ma_qty">
            <label class="weui-form-preview__label">{{customLabel.ma_qty || "数量"}}</label>
            <span class="weui-form-preview__value">
              <span v-format="'#,##0.#'">{{ form.main.ma_qty }}</span>
              &nbsp;{{ form.main.pr_unit }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ma_planbegindate">
            <label class="weui-form-preview__label">{{customLabel.ma_planbegindate || "计划开工"}}</label>
            <span class="weui-form-preview__value">
              <span v-format="'yyyy-MM-dd'">{{
                form.main.ma_planbegindate
              }}</span
              >&nbsp;~&nbsp;
              <span v-format="'yyyy-MM-dd'">{{
                form.main.ma_planenddate
              }}</span>
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_madeqty" slot="ma_madeqty">
            <label class="weui-form-preview__label">{{customLabel.ma_madeqty || "已完工"}}</label>
            <span class="weui-form-preview__value" v-format="'#,##0.#'">{{
              form.main.ma_madeqty
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.mm_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.mm_prodcode }} {{ item.productDTO.pr_detail }}</span
              >
            </div>
            <div
              class="weui-form-preview__item" slot="pr_brand"
              v-if="item.productDTO.pr_brand"
            >
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_brand
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode"
            >
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="mm_oneuseqty">
              <label class="weui-form-preview__label">{{customLabel.mm_oneuseqty || "单位用量"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.mm_oneuseqty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="mm_qty">
              <label class="weui-form-preview__label">{{customLabel.mm_qty || "需求数"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ numberFormat(item.mm_qty,'#,##0.#') }}</span>
                &nbsp;{{ item.productDTO.pr_unit }}
              </span>
            </div>
            <div class="weui-form-preview__item" v-if="item.mm_havegetqty" slot="mm_havegetqty">
              <label class="weui-form-preview__label">{{customLabel.mm_havegetqty || "已领数"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ numberFormat(item.mm_havegetqty,'#,##0.#') }}</span>
                &nbsp;{{ item.productDTO.pr_unit }}
              </span>
            </div>
            <div class="weui-form-preview__item" v-if="item.mm_returnmqty" slot="mm_returnmqty">
              <label class="weui-form-preview__label">{{customLabel.mm_returnmqty || "制程不良数"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.mm_returnmqty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
            <div class="weui-form-preview__item" v-if="item.mm_scrapqty" slot="mm_scrapqty">
              <label class="weui-form-preview__label">{{customLabel.mm_scrapqty || "报废数"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.mm_scrapqty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
          </custom-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/make/make",
      caller: "Make",
      xtype: "make-makebase-formpanel",
    };
  },
};
</script>